import { icons } from '../icons';
import React from 'react';
import { Link } from 'react-router-dom';
import KoobButton from './KoobButton';

type KoobCreateButtonProps = Omit<
  React.ComponentProps<typeof KoobButton>,
  'variant' | 'asChild'
> & {
  /** Renders a react-router Link to the create route. */
  to?: React.ComponentProps<typeof Link>['to'];
  relative?: React.ComponentProps<typeof Link>['relative'];
};

// The one true "create" button: primary variant + circle-plus icon.
// Pass `to` for navigation call sites, `onClick` for modal-opening ones.
const KoobCreateButton = React.forwardRef<
  HTMLButtonElement,
  KoobCreateButtonProps
>(({ to, relative, children, ...props }, ref) => {
  const content = (
    <>
      <i className={icons.add} />
      {children}
    </>
  );

  if (to) {
    return (
      <KoobButton ref={ref} variant="primary" asChild {...props}>
        <Link to={to} relative={relative}>
          {content}
        </Link>
      </KoobButton>
    );
  }

  return (
    <KoobButton ref={ref} variant="primary" {...props}>
      {content}
    </KoobButton>
  );
});

KoobCreateButton.displayName = 'KoobCreateButton';

export default KoobCreateButton;
